import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

const fbApp = initializeApp({
    apiKey: "AIzaSyBHpA1Uds_luHO9NVN-dWDvyIdF5dqoaUU",
    authDomain: "bindoo-collectives.firebaseapp.com",
    databaseURL: "https://bindoo-collectives-default-rtdb.firebaseio.com",
    projectId: "bindoo-collectives",
    storageBucket: "bindoo-collectives.appspot.com",
    messagingSenderId: "937810583466",
    appId: "1:937810583466:web:c5529466aa64a68289d5d3",
    measurementId: "G-VBRMTC048E"
})

const dbApp = getFirestore(fbApp)
export const app = fbApp;
export const auth = getAuth(fbApp)
export const db = dbApp
export const storage = getStorage(fbApp)
export const msg = getMessaging(fbApp)